import { useContext } from 'react';
import { createPortal } from 'react-dom';

import { ConfigHeaderContext } from '../../hooks/useConfigHeader';

/**
 * Renders its children in the floating header card's action slot (right side)
 * from wherever the subpage renders it. Being a portal, the buttons stay part
 * of the subpage's tree: their handlers are always the current render's, with
 * no effect dependencies to keep in sync.
 */
export default function ConfigHeaderActions({ children }) {
    const { actionsSlot } = useContext(ConfigHeaderContext);
    if (!actionsSlot) return null;
    return createPortal(children, actionsSlot);
}
